import React from 'react';

const CountryIcon = ({ className }) => (
    <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={className}
    >
        <g clipPath='url(#clip0_545_84221)'>
            <path d='M3 14V3.5' stroke='#00225F' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            <path
                d='M3 11.0001C7 7.5357 10 14.4645 14 11.0001V3.50008C10 6.96445 7 0.0357039 3 3.50008'
                stroke='#00225F'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </g>
        <defs>
            <clipPath id='clip0_545_84221'>
                <rect width='16' height='16' fill='white' />
            </clipPath>
        </defs>
    </svg>
);

export { CountryIcon };
